import businessClient from 'src/services/clients/business'
import { IMeta, IModifier, IModifierItemUpsertArgs } from 'src/common/interfaces/index.js'

const IModifierListResponse = { meta: IMeta, data: { list: [IModifier] } }

export const inventoryModifierItem = {
  /**
   * @param {id: number} filter
   * @return {IModifierListResponse}
   */
  list(filter, signal) {
    return businessClient().post('inventory/modifier/item/portal/list', { filter }, { signal })
  },

  /**
   * @param {IModifierItemUpsertArgs} data
   * @return {IInsertResponse}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/modifier/item/upsert', { data }, { signal })
  },
}
